import React from "react";
import AboutHero from "../components/about/AboutHero";
import AboutStory from "../components/about/AboutStory";
import AboutValues from "../components/about/AboutValues";
import AboutImpact from "../components/about/AboutImpact";
import AboutCta from "../components/about/AboutCta";

const About = () => {
  return (
    <div className="w-full overflow-x-hidden">
      <AboutHero />
      <AboutStory />
      <AboutValues />
      <AboutImpact />
      <AboutCta />
    </div>
  );
};

export default About;
